import { MutationType } from '@tencent/slide-sdk-pb-model';
import type { MaybeMutationData } from './valid-mutation-data';

export function isPageMutation(mutation: MaybeMutationData) {
    return [MutationType.AddPage, MutationType.RemovePage, MutationType.SetPageProperties].includes(mutation.type);
}

export function isPageInsideChangeMutation(mutation: MaybeMutationData) {
    if (isPageMutation(mutation)) {
        return false;
    }
    return !!Reflect.get(mutation, 'pageId');
}
